import React from 'react';
import { useNavigate } from 'react-router-dom';

const MASTER_MODULES = [
  {
    key: 'panels',
    title: 'Panel Master',
    subtitle: 'Cash PUPs, corporate contracts, and tariff inheritance',
    path: '/masters/panels',
    color: '#0284c7',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    )
  },
  {
    key: 'parties',
    title: 'B2B Client / Party Master',
    subtitle: 'Corporates, hospital tie-ups, clinics & franchise collection centers',
    path: '/masters/parties',
    color: '#059669',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  },
  {
    key: 'contracts',
    title: 'Rate Contract Master',
    subtitle: 'B2B commercial price lists, validities & itemized contract tariffs',
    path: '/masters/contracts',
    color: '#d97706',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    )
  },
  {
    key: 'microbiology',
    title: 'Microbiology Masters (Pathology)',
    subtitle: 'Pathology sub-specialty: Organisms, Antimicrobials, AST Panels, Breakpoints & Rules',
    path: '/masters/microbiology',
    color: '#0284c7',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 3a9 9 0 0 1 9 9M12 3a9 9 0 0 0-9 9" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    )
  },
  {
    key: 'investigations',
    title: 'Investigation Master',
    subtitle: 'Pathology, Radiology & diagnostic test catalog',
    path: '/masters/investigations',
    color: '#6366f1',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5h0c-1.4 0-2.5-1.1-2.5-2.5V2" />
        <path d="M8.5 2h7" />
        <path d="M14.5 16h-5" />
      </svg>
    )
  },
  {
    key: 'profiles',
    title: 'Profile / Panel Master',
    subtitle: 'Clinical test groupings, lipid panels, diabetic profiles',
    path: '/masters/profiles',
    color: '#8b5cf6',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" />
      </svg>
    )
  },
  {
    key: 'packages',
    title: 'Package Master',
    subtitle: 'Executive health checkups, commercial test & profile bundles',
    path: '/masters/packages',
    color: '#ec4899',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    )
  },
  {
    key: 'radiology-templates',
    title: 'Radiology Template Master',
    subtitle: 'Doctor report templates, normal findings, DOCX single & bulk ZIP import',
    path: '/masters/radiology-templates',
    color: '#0284c7',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    )
  },
  {
    key: 'observations',
    title: 'Observation & Analyte Master',
    subtitle: 'Numeric, narrative & formula analytes with biological ranges',
    path: '/masters/observations',
    color: '#10b981',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    )
  },
  {
    key: 'formulas',
    title: 'Formula Intelligence Master',
    subtitle: 'AI-assisted medical calculations, expressions & dependency graphs',
    path: '/masters/formulas',
    color: '#6366f1',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
        <path d="M8 7h6" />
        <path d="M11 11h3" />
        <path d="M8 15h6" />
      </svg>
    )
  },
  {
    key: 'departments',
    title: 'Department Master',
    subtitle: 'Clinical subcategories, reporting sequence and lab routing',
    path: '/masters/departments',
    color: '#f59e0b',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
      </svg>
    )
  },
  {
    key: 'specimens',
    title: 'Specimen & Tube Master',
    subtitle: 'Sample matrices, collection tubes & color vacutainers',
    path: '/masters/specimens',
    color: '#ec4899',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    )
  },
  {
    key: 'worksheet-templates',
    title: 'Worksheet Template Master',
    subtitle: 'Printable laboratory worksheet formats, multi-layout engine & technician print designs',
    path: '/masters/worksheet-templates',
    color: '#0284c7',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="9" y1="21" x2="9" y2="9" />
      </svg>
    )
  },
  {
    key: 'reference-labs',
    title: 'Reference Laboratory Master',
    subtitle: 'External partner network, accreditations, agreements & default TAT',
    path: '/masters/reference-labs',
    color: '#8b5cf6',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 21h18M3 7v14M21 7v14M6 7V3h12v4M9 11h2M13 11h2M9 15h2M13 15h2" />
      </svg>
    )
  },
  {
    key: 'outsource-mappings',
    title: 'Outsource Test Mappings',
    subtitle: 'Map internal investigations to reference labs, external codes, methods & B2B rates',
    path: '/masters/outsource-mappings',
    color: '#06b6d4',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <polyline points="16 3 21 3 21 8" />
        <line x1="4" y1="20" x2="21" y2="3" />
        <polyline points="21 16 21 21 16 21" />
        <line x1="15" y1="15" x2="21" y2="21" />
        <line x1="4" y1="4" x2="9" y2="9" />
      </svg>
    )
  },
  {
    key: 'referral-sources',
    title: 'Referral Sources & Doctors',
    subtitle: 'Generic referral entities: Hospitals, Clinics, Labs, Corporates & Associated Clinicians',
    path: '/masters/referral-sources',
    color: '#0284c7',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  },
  {
    key: 'referral-share',
    title: 'Referral Share Configuration',
    subtitle: 'Department, Item & Package multi-level commission matrix, copy rules & transfer engine',
    path: '/masters/referral-share',
    color: '#10b981',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    )
  },
  {
    key: 'clinicians',
    title: 'Referring Clinician Master',
    subtitle: 'Consultants, referring doctors, hospital affiliations',
    path: '/masters/clinicians',
    color: '#8b5cf6',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  },
  {
    key: 'centres',
    title: 'Centre Master',
    subtitle: 'Diagnostic processing hubs, collection facilities & NABL',
    path: '/masters/centres',
    color: '#06b6d4',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    )
  },
  {
    key: 'locations',
    title: 'Location Master Hierarchy',
    subtitle: 'Relational Country → State → City → PIN Code → Address hierarchy',
    path: '/masters/locations',
    color: '#3b82f6',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="2" y1="12" x2="22" y2="12" />
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
      </svg>
    )
  },
  {
    key: 'panel-rates',
    title: 'Panel-Wise Rate List',
    subtitle: 'One Panel to Multiple Tests price schedule editor',
    path: '/masters/panel-rates',
    color: '#14b8a6',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="12" y1="1" x2="12" y2="23" />
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
      </svg>
    )
  },
  {
    key: 'centre-panel-mapping',
    title: 'Centre – Panel Commercial Mapping',
    subtitle: 'Map physical centres to commercial referral, partner & corporate panels',
    path: '/masters/centre-panel-mapping',
    color: '#0284c7',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    )
  },
  {
    key: 'item-rates',
    title: 'Item-Wise Rate List',
    subtitle: 'One Test to Multiple Panels tariff cross-comparison',
    path: '/masters/item-rates',
    color: '#e11d48',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M9 11l3 3L22 4" />
        <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
      </svg>
    )
  },
  {
    key: 'mapping',
    title: 'Parameter Mapping Workspace',
    subtitle: 'Link investigations to multi-parameter analytes',
    path: '/investigation-observation-mapping',
    color: '#3b82f6',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
    )
  },
  {
    key: 'nabl',
    title: 'NABL Report Config',
    subtitle: 'ISO 15189 compliance stamps, scope and report logos',
    path: '/nabl-config',
    color: '#64748b',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="8" r="7" />
        <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
      </svg>
    )
  },
  {
    key: 'analyzer-models',
    title: 'Analyzer Model Catalog',
    subtitle: 'Central Level-1 machine models, ASTM/HL7 communication & protocol master',
    path: '/masters/analyzer-models',
    color: '#0284c7',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="4" y="4" width="16" height="16" rx="2" />
        <rect x="9" y="9" width="6" height="6" />
        <line x1="9" y1="1" x2="9" y2="4" />
        <line x1="15" y1="1" x2="15" y2="4" />
        <line x1="9" y1="20" x2="9" y2="23" />
        <line x1="15" y1="20" x2="15" y2="23" />
        <line x1="20" y1="9" x2="23" y2="9" />
        <line x1="20" y1="14" x2="23" y2="14" />
        <line x1="1" y1="9" x2="4" y2="9" />
        <line x1="1" y1="14" x2="4" y2="14" />
      </svg>
    )
  },
  {
    key: 'analyzers',
    title: 'Physical Analyzer Master',
    subtitle: 'Center-installed machine instances, serial numbers, credentials & status',
    path: '/masters/analyzers',
    color: '#059669',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="3" width="20" height="14" rx="2" />
        <line x1="8" y1="21" x2="16" y2="21" />
        <line x1="12" y1="17" x2="12" y2="21" />
      </svg>
    )
  }
];

export const MasterDirectoryHub = () => {
  const navigate = useNavigate();

  return (
    <div className="page-container fade-in">
      <div className="breadcrumb">
        <button type="button" onClick={() => navigate('/dashboard')}>
          Home
        </button>
        <span className="breadcrumb-divider">/</span>
        <span className="breadcrumb-active">Masters Directory</span>
      </div>

      <div className="page-header" style={{ marginBottom: '2rem' }}>
        <div className="page-title-group">
          <h1 className="page-title">Enterprise Masters Directory</h1>
          <span className="page-subtitle">
            Select a master below to create records or manage catalogs.
          </span>
        </div>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
          gap: '1.25rem'
        }}
      >
        {MASTER_MODULES.map((m) => (
          <div
            key={m.key}
            className="glass-card"
            style={{
              padding: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              cursor: 'pointer',
              transition: 'var(--transition-smooth)'
            }}
            onClick={() => navigate(m.path)}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.borderColor = m.color;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = 'var(--card-border)';
            }}
          >
            <div>
              <div
                style={{
                  width: '46px',
                  height: '46px',
                  borderRadius: '10px',
                  backgroundColor: `${m.color}15`,
                  color: m.color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '1rem'
                }}
              >
                {m.icon}
              </div>
              <h3
                style={{
                  margin: '0 0 0.4rem 0',
                  fontSize: '1.1rem',
                  fontWeight: 700,
                  color: 'var(--text-primary)'
                }}
              >
                {m.title}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '0.85rem',
                  color: 'var(--text-muted)',
                  lineHeight: 1.5
                }}
              >
                {m.subtitle}
              </p>
            </div>

            <div
              style={{
                marginTop: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                paddingTop: '0.85rem',
                borderTop: '1px solid var(--border-color)',
                fontSize: '0.85rem',
                fontWeight: 600,
                color: m.color
              }}
            >
              <span>Open Master</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MasterDirectoryHub;
